import { useEffect, useState, useRef } from "react";

const useFadeInOnScroll = () => {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 0px -15% 0px",
        threshold: 0.12,
      }
    );

    const { current } = domRef;
    if (current) {
      observer.observe(current);
    }

    return () => observer.disconnect();
  }, []);

  return [isVisible, domRef];
};

export default useFadeInOnScroll;
